<app-header #header></app-header>

<ion-content>
  <div class="container">

    <ion-card class="parent-one">
      <div class="rich-text" [innerHTML]="rankingResponse?.ranking?.description"></div>
    </ion-card>
  
    <ion-card class="parent-two">
      <h6><strong>TU PROGRESO ACTUAL</strong></h6>
      <div class="semaforo-horizontal">
        <div class="progress-meter"
          [style.left.%]="progress">
          <ion-icon name="caret-down-outline"></ion-icon>
          <span>{{ progress }}% <br>Tu avance </span>
        </div>
        <div class="level rojo">
          <span>Debes seguir</span>
        </div>
        <div class="level naranja">
          <span>A punto de ganar!</span>
        </div>
        <div class="level verde">
          <span>Grupo ganador</span>
        </div>
      </div>
      <h6 *ngIf="rankingResponse?.invoices_uploaded" ><strong>Total de facturas subidas en el período: {{rankingResponse?.invoices_uploaded}}</strong></h6>
      <h6 *ngIf="rankingResponse?.points_earned"><strong>Total de {{ companyInfo?.points_name }} acumulados en el período: {{rankingResponse?.points_earned |
            currency : 'COP':''}}</strong></h6>
    </ion-card>
  
    <ion-card class="parent-three">
      <h6><strong>Estado según el avance</strong></h6>
      <div [class.selected]="progress < 33" >Sigue participando para avanzar.</div>
      <div [class.selected]="progress >= 33 && progress <= 66">¡Ya casi! Estás a punto de entrar al grupo ganador.</div>
      <div [class.selected]="progress > 66">¡Felicitaciones! Estás en el grupo ganador.</div>
    </ion-card>
  
    <ion-card class="parent-four">
      <h6><strong>RECOMPENSAS DESTACADAS</strong></h6>
      <div class="card-content">
        <ion-grid>
          <ion-row>

            <ion-col size="12" size-md="6" size-lg="3">
              <ion-card>
                <ion-card-header>
                  <ion-card-title>Bonos por 250.000</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  Top 40 asesores
                </ion-card-content>
              </ion-card>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="3">
              <ion-card>
                <ion-card-header>
                  <ion-card-title>Bonos por 200.000</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  Siguientes 65 Asesores
                </ion-card-content>
              </ion-card>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="3">
              <ion-card>
                <ion-card-header>
                  <ion-card-title>Bonos por 150.000</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  Siguientes 90 Asesores
                </ion-card-content>
              </ion-card>
            </ion-col>

            <ion-col size="12" size-md="6" size-lg="3">
              <ion-card>
                <ion-card-header>
                  <ion-card-title>Bonos por 100.000</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                  Siguientes 165 Asesores
                </ion-card-content>
              </ion-card>
            </ion-col>

          </ion-row>
        </ion-grid>
      </div>
      
    </ion-card>
    <!-- <div class="buttons">
      <ion-button>Ver cómo ganar más</ion-button>
      <ion-button>Ver reglas del programa</ion-button>
    </div> -->
  </div>

</ion-content>
